import Grid2 from '@mui/material/Unstable_Grid2';

import BlogCard from '@/components/BlogComponents/shared/BlogCard/BlogCard';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type {
  BlogPageType,
  CuratedArticleGridType,
} from '@/contentful/api/api.types';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './BlogArticle2Up.styles';

export default function BlogArticle2Up({
  content,
}: {
  content: CuratedArticleGridType;
}): React.JSX.Element {
  const { articlesCollection, heading } = content;
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <SpacingContainer isFeatured className={classes.spacingContainer}>
      <GridContainer2 fixed gridProps={{ className: classes.grid }}>
        {heading && (
          <Grid2 xs={12}>
            <h2 className={cx(globalClasses.h2, classes.articleHeading)}>
              {heading}
            </h2>
          </Grid2>
        )}
        {articlesCollection?.items.map((article: BlogPageType, idx) => {
          const {
            blogTitle,
            heroImage,
            publicationDate,
            category,
            categoryPath,
            readTimeMinutes,
            path,
          } = article;

          return (
            <Grid2
              key={`${blogTitle}-${publicationDate}`}
              xs={12}
              sm={idx <= 3 ? 6 : 4}
            >
              <BlogCard
                image={heroImage}
                title={blogTitle}
                url={path}
                date={publicationDate}
                readTime={readTimeMinutes}
                categoryPath={categoryPath}
                category={category}
              />
            </Grid2>
          );
        })}
      </GridContainer2>
    </SpacingContainer>
  );
}
